export const LEGEND_CLASS_NAMES: { [key: string]: string } = {
  'earned-skymiles': 'bg-loyalty-surface-tier-01-primary',
  'pending-skymiles': 'bg-member-50',
  'earned-silver': 'bg-loyalty-surface-tier-02-primary',
  'pending-silver': 'bg-silver-50',
  'earned-gold': 'bg-loyalty-surface-tier-03-primary',
  'pending-gold': 'bg-gold-50',
  'earned-platinum': 'bg-loyalty-surface-tier-04-primary',
  'pending-platinum': 'bg-platinum-50',
  'earned-diamond': 'bg-loyalty-surface-tier-05-primary',
  'pending-diamond': 'bg-diamond-50',
  'earned-360': 'bg-loyalty-surface-tier-06-primary',
  'pending-360': 'bg-delta-360-50'
};
